import http from '../const/http-common'

const getVisualizataionList = () => {
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  
  return http.get('/v1/user/visualization/list', { headers });
}

const createVisualization = (info) => {
  console.log('info')
  const { name } = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  
  return http.post('/v1/user/visualization/create', { name }, { headers });
}

const deleteVisualization = (info) => {
  const { id } = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }
  
  return http.delete(`/v1/user/visualization/${id}/delete`, { headers });
}

const updateVisualization = (info) => {
  const {id, name} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  
  return http.put('/v1/user/visualization/update', {id, name}, { headers });
}

const setVisualization = (info) => {
  const {name, prompt} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  
  return http.post('/v1/user/visualization/graph/create', {name, prompt}, { headers });
}

const saveVisualization = (info) => {
  const {id, data, layouts} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  
  return http.post('/v1/user/visualization/graph/save', {id, data, layouts}, { headers });
}

const getVisualization = (info) => {
  const {id} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  
  return http.post('/v1/user/visualization/graph/get', {id}, { headers });
}

const generatePDF = (info) => {
  const {id} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  
  return http.get(`/v1/user/visualization/${id}/generate`, { headers });
}

const scheduleVisualization = (info) => {
  const {id, title, recurrence, day, time, destinations} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }

  return http.post(`/v1/user/presentation/schedule`, {id, mode: 'visualization', title, recurrence, day, time, destinations}, { headers });
}

const updateScheduleVisualization = (info) => {
  const {scheduleID, id, title, recurrence, day, time, destinations} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }

  return http.post(`/v1/user/presentation/update_schedule`, {scheduleID, id, mode: 'visualization', title, recurrence, day, time, destinations}, { headers });
}

const deleteSchedule = (info) => {
  const {scheduleID} = info;
  
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }


  return http.delete(`/v1/user/presentation/${scheduleID}/schedule`, { headers });
}

const loadSchedule = (info) => {
  const {id, mode} = info;
  const token = localStorage.getItem("token")
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true,
    'Content-Type': 'application/json'
  }

  return http.post(`/v1/user/presentation/load_schedule`, {id, mode}, { headers });
}

const visualizationService = {
  getVisualizataionList,
  createVisualization,
  updateVisualization,
  deleteVisualization,
  setVisualization,
  saveVisualization,
  getVisualization,
  generatePDF,
  scheduleVisualization,
  loadSchedule,
  updateScheduleVisualization,
  deleteSchedule
}

export default visualizationService